export default __webpack_public_path__ + "static/media/green_tick.5237f449.svg";